import { render, staticRenderFns } from "./SettingScaleInfo.vue?vue&type=template&id=e4309510&scoped=true"
import script from "./SettingScaleInfo.vue?vue&type=script&lang=js"
export * from "./SettingScaleInfo.vue?vue&type=script&lang=js"
import style0 from "./SettingScaleInfo.vue?vue&type=style&index=0&id=e4309510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4309510",
  null
  
)

export default component.exports